import { NUMBER_SEPARATORS_BY_LANGUAGE } from "constants/currency";

export const capitalizeFirstLetter = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const getSeparatorsForLanguage = (language: string) => {
  const key = (language || "en").slice(0, 2).toLowerCase();
  const localeSeparators = NUMBER_SEPARATORS_BY_LANGUAGE[key];

  return {
    thousandSeparator: localeSeparators?.thousandSeparator ?? ",",
    fractionalSeparator: localeSeparators?.fractionalSeparator ?? ".",
    millionSeparator:
      localeSeparators?.millionSeparator ??
      localeSeparators?.thousandSeparator ??
      ",",
  };
};

export const formatFractionalAndThousand = (
  numberAmount: number,
  languageCode: string,
) => {
  const { thousandSeparator, fractionalSeparator, millionSeparator } =
    getSeparatorsForLanguage(languageCode);

  const safeMillionSeparator = millionSeparator ?? thousandSeparator;

  const amountString = numberAmount.toString();
  const amountLength = amountString.length;

  if (amountLength === 3) {
    const fractionalPart = amountString.slice(-2);
    const integerPart = amountString.slice(0, 1);
    return `${integerPart}${fractionalSeparator}${fractionalPart}`;
  }

  if (amountLength >= 4 && amountLength <= 5) {
    // от '10 00' до '100 00'
    const fractionalPart = amountString.slice(-2);
    const mainPart = amountString.slice(-5, -2);
    return `${mainPart}${fractionalSeparator}${fractionalPart}`;
  }

  if (amountLength >= 6 && amountLength <= 8) {
    // от '1 000 00' до '100 000 00'
    const fractionalPart = amountString.slice(-2);
    const mainPart = amountString.slice(-5, -2);
    const thousandPart = amountString.slice(-8, -5);
    return `${thousandPart}${thousandSeparator}${mainPart}${fractionalSeparator}${fractionalPart}`;
  }

  if (amountLength === 9) {
    // '1 000 000 00'
    const fractionalPart = amountString.slice(-2);
    const mainPart = amountString.slice(-5, -2);
    const thousandPart = amountString.slice(-8, -5);
    const millionPart = amountString.slice(0, 1);
    return `${millionPart}${safeMillionSeparator}${thousandPart}${thousandSeparator}${mainPart}${fractionalSeparator}${fractionalPart}`;
  }

  if (amountLength === 10) {
    // '10 000 000 00'
    const fractionalPart = amountString.slice(-2);
    const mainPart = amountString.slice(-5, -2);
    const thousandPart = amountString.slice(-8, -5);
    const millionPart = amountString.slice(0, 2);
    return `${millionPart}${safeMillionSeparator}${thousandPart}${thousandSeparator}${mainPart}${fractionalSeparator}${fractionalPart}`;
  }

  return "0";
};

export function splitAmountString(amountString, fractionalSeparatorString) {
  const parts = amountString.split(fractionalSeparatorString);
  if (parts.length > 1) {
    const fractionalPart = parts[1];
    if (fractionalPart === "00") {
      return amountString.slice(0, -3);
    }
  }
  return amountString;
}
